import { ModalsSlice, TutorialsApi } from '@hefe/store';
import { Button, Carousel, Col, Row, Spin } from 'antd';
import TutorialStepComponent from '../tutorial-step/tutorial-step.component';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { t } from '@hefe/i18n';
import { useMemo, useState } from 'react';
import { useAppDispatch } from '../../../../store/store';

interface TutorialComponentProps {
  id: number;
}

export default function TutorialComponent(props: TutorialComponentProps) {
  const { id } = props;

  const dispatch = useAppDispatch();

  const { data: tutorial, isLoading } = TutorialsApi.useFetchTutorialQuery(
    id ?? 0
  );
  const [markTutorialAsRead] = TutorialsApi.useMarkTutorialAsReadMutation();

  const [currentStep, setCurrentStep] = useState(0);

  const showCloseButton = useMemo(() => {
    if (!tutorial?.steps) {
      return false;
    }

    return !tutorial?.mandatory || currentStep === tutorial?.steps.length - 1;
  }, [tutorial, currentStep]);

  const onTutorialClose = () => {
    if (!tutorial) {
      return;
    }

    markTutorialAsRead(id);
    dispatch(ModalsSlice.modalsActions.closeTutorialModal());
  };

  if (isLoading) {
    return <Spin />;
  }

  return (
    <>
      <Row>
        <Col span={24}>
          <Carousel
            arrows
            nextArrow={<ArrowRightOutlined />}
            prevArrow={<ArrowLeftOutlined />}
            infinite={false}
            afterChange={(current) => setCurrentStep(current)}
          >
            {tutorial?.steps &&
              tutorial?.steps.map((step, index) => (
                <TutorialStepComponent
                  key={step.id}
                  step={step}
                  number={index + 1}
                />
              ))}
          </Carousel>
        </Col>
      </Row>
      <Row justify="end" style={{ marginTop: 20 }}>
        <Col span={3}>
          {showCloseButton && (
            <Button type="primary" onClick={() => onTutorialClose()}>
              {t('close')}
            </Button>
          )}
        </Col>
      </Row>
    </>
  );
}
